<div class="flex flex-col h-full">
  <!-- header -->
  <div mat-dialog-title>
    <div class="flex flex-1 flex-wrap items-center font-bold">{{ translations.title.text }}</div>

    <button
      id="import-dialog-close"
      modus-icon-button
      modus-tooltip="{{ translations.minimize.text }}"
      (click)="minimizeClick()"
      [disabled]="disableMinimize()"
    >
      <md-icon>remove</md-icon>
    </button>

    <button
      id="import-dialog-close"
      modus-icon-button
      modus-tooltip="{{ translations.close.tooltip.text }}"
      (click)="cancelClick()"
      [disabled]="disableCancel()"
      class="ml-4"
    >
      <md-icon>close</md-icon>
    </button>
  </div>

  <!-- content -->
  <mat-dialog-content class="!pb-0 !border-0 overflow-hidden gap-4">
    @switch (importStatus()) {
      @case (status.NotStarted) {
        @if (maxFilesReached()) {
          <modus-alert class="w-full" type="warning" [message]="maxFilesMessage()"></modus-alert>
        } @else {
          @if (hasFilesWithErrors()) {
            <modus-alert
              class="w-full"
              type="error"
              message="{{ translations.status.selectionError.text }}"
            ></modus-alert>
          }

          @if (enableLocalFilePicker()) {
            <sd-local-file-picker
              class="flex min-h-60 h-60"
              (filesPicked)="addFiles($event)"
            ></sd-local-file-picker>
          }

          @if (showWebFilePickers()) {
            <div class="flex">
              @for (filePicker of webFilePickers(); track $index) {
                <button
                  [modus-tooltip]="filePicker.tooltip"
                  (click)="filePickerClick(filePicker)"
                  class="h-8 p-1 mr-1 text-gray-6 hover:text-trimble-blue hover:bg-gray-1"
                >
                  <mat-icon [svgIcon]="filePicker.icon"></mat-icon>
                </button>
              }
            </div>
          }
        }
      }
      @case (status.Busy) {
        <div class="flex flex-col items-center justify-center text-trimble-gray">
          <img src="/assets/import-in-progress.png" />
          <div class="text-lg font-semibold mt-2">
            {{ translations.status.inProgress.title.text }}
          </div>
          <div class="text-center text-sm my-2">
            {{ translations.status.inProgress.message.text }}
          </div>
        </div>
      }
      @case (status.Error) {
        <modus-alert
          class="w-full"
          type="error"
          message="{{ translations.status.error.text }}"
        ></modus-alert>
      }
      @case (status.Completed) {
        <modus-alert
          class="w-full"
          type="success"
          message="{{ translations.status.complete.text }}"
        ></modus-alert>
      }
    }

    <sd-import-file-list
      class="flex"
      [importFiles]="importFiles()"
      [disableRemove]="importStarted()"
      (removeFiles)="removeFiles($event)"
    ></sd-import-file-list>
  </mat-dialog-content>

  <!-- actions -->
  <mat-dialog-actions class="!border-0">
    <sd-import-time-remaining
      class="flex w-full items-center justify-end text-small italic text-gray-8"
      [importStatus]="importStatus()"
      [importScans]="importScans()"
    ></sd-import-time-remaining>

    <div class="flex flex-col w-full">
      <div class="flex flex-col ml-1">
        <modus-switch
          class="select-none"
          data-cy="import-dialog-combine-switch"
          label="{{ translations.combine.text }}"
          [formControl]="combineControl"
        ></modus-switch>

        @if (enableClassifier()) {
          <div>
            <div class="flex text-sm text-gray-8 my-2">
              <modus-switch
                class="select-none flex"
                [label]="translations.classify.text"
                [formControl]="runClassifierControl"
              ></modus-switch>
              <md-icon
                class="ml-2"
                [modus-tooltip]="translations.experimental.tooltip.text"
                [ngClass]="runClassifierControl.enabled ? 'text-trimble-blue' : 'text-gray-2'"
                >labs</md-icon
              >
            </div>
            @if (showClassierTypes()) {
              <mat-radio-group class="ml-9" [formControl]="classifierTypeControl">
                <mat-radio-button color="primary" [value]="classifierType.Terrestrial">
                  <div class="text-small">{{ classifierTerrestrialLabel }}</div>
                </mat-radio-button>
                <mat-radio-button color="primary" class="ml-4" [value]="classifierType.Aerial">
                  <div class="text-small">{{ classifierAerialLabel }}</div>
                </mat-radio-button>
                @if (showIndoorClassifier()) {
                  <mat-radio-button color="primary" class="ml-4" [value]="classifierType.Indoor">
                    <div class="text-small">{{ classifierIndoorLabel }}</div>
                  </mat-radio-button>
                }
              </mat-radio-group>
            }
          </div>
        }
      </div>

      <div class="flex grow justify-end">
        <button
          id="import-dialog-cancel"
          modus-button
          color="secondary"
          (click)="cancelClick()"
          [disabled]="disableCancel()"
        >
          {{ cancelButtonText() }}
        </button>
        <button
          id="import-dialog-import"
          modus-flat-button
          color="primary"
          class="ml-4"
          (click)="importClick()"
          [disabled]="disableImport()"
        >
          {{ translations.start.text }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
